import { Component, signal } from '@angular/core';
import { SequenceEventFormComponent } from "@app/components/forms/sequence-event/form.component";
import { SequenceEventHelperService } from '@app/services/helpers/sequence-event-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { SequenceEventCreate } from '@app/models/sequence-event.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';

@Component({
    selector: 'app-sequence-events-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        SequenceEventFormComponent,
        RouterModule,
        FontAwesomeModule,
    ]
})
export class SequenceEventCreatePage {
  public title = 'New Sequence Event';
  formValid = signal(false);
  formValue = signal<SequenceEventCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private sequenceEventService: SequenceEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.sequenceEventService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/sequence-events/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
